import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { FormatsSettingsFormDatesSection } from './FormatsSettingsFormDatesSection';

export type IFormatsSettingsFormValues = {
  articleDateFormat?: string;
  categoryDateFormat?: string;
  feedDateFormat?: string;
};

export type IFormatsSettingsFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IFormatsSettingsFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IFormatsSettingsFormValues>;
    onSubmit?: SubmitHandler<IFormatsSettingsFormValues>;
  };

export const FormatsSettingsForm: React.FC<IFormatsSettingsFormProps> = (
  props,
) => {
  const { sx, defaultValues, onSubmit, ...other } = props;

  const form = useForm<IFormatsSettingsFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <FormatsSettingsFormDatesSection form={form} />
    </ContentBlock.FormBody>
  );
};
